
        import '/home/builduser/work/97f164ade279074e/santa-editor/packages/wixData/components/emptyExternalDbItem/emptyExternalDbItem.scss.css.virtualfile';
        module.exports = {"emptyText":"_emptyText_1n6lv_1"};